import { axios, fileAxios } from '../plugins/axios';
import ROLES from '../roles';

export default {
  namespaced: true,

  state: {
    derivaciones: [],
  },

  getters: {
    getDerivaciones: (state, getters, rootState) => {
      const ESTATUS_VALIDACION_SUPERVISOR = 4;
      const ESTATUS_ACTIVO = 2;
      const ESTATUS_PENDIENTE = 1;

      if (!rootState.selectedRole || rootState.selectedRole === ROLES.DIRECTOR_GENERAL) {
        return state.derivaciones;
      }

      if (rootState.selectedRole === ROLES.DIRECTOR_AREA) {
        return state.derivaciones.filter(
          (derivacion) => derivacion.fk_idCatEstatus === ESTATUS_VALIDACION_SUPERVISOR,
        );
      }

      return state.derivaciones.filter(
        (derivacion) => derivacion.fk_idCatEstatus === ESTATUS_ACTIVO || derivacion.fk_idCatEstatus === ESTATUS_PENDIENTE,
      );
    },
  },

  mutations: {
    SET_DERIVACIONES(state, derivaciones) {
      state.derivaciones = derivaciones;
    },
  },

  actions: {
    async fetchDerivacionesByProgramacionEvaluacion({ commit }, idProgramacionEvaluacion) {
      await axios
        .get(`PoliciaCuadrantes/C3/programacionesevaluaciones/${idProgramacionEvaluacion}/derivaciones`)
        .then((response) => {
          commit('SET_DERIVACIONES', response.data.data);
        });
    },

    consultaDerivacionesByProgramacionEvaluacion(_, idProgramacionEvaluacion) {
      return axios
        .get(`PoliciaCuadrantes/C3/programacionesevaluaciones/${idProgramacionEvaluacion}/derivaciones`)
        .then((response) => response.data.data);
    },

    async fetchDerivacionesByArea({ commit }, idArea) {
      await axios
        .get(`PoliciaCuadrantes/C3/derivaciones/area/${idArea}`)
        .then((response) => {
          commit('SET_DERIVACIONES', response.data.data);
        });
    },

    async fetchDerivacionesByUsuario({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/derivaciones/area/usuario')
        .then((response) => {
          commit('SET_DERIVACIONES', response.data.data);
        });
    },

    async saveDerivacion(_, derivacion) {
      await axios
        .post(`PoliciaCuadrantes/C3/programacionesevaluaciones/${derivacion.idProgramacionEvaluacion}/derivaciones`, derivacion);
    },

    async updateDerivacion(context, derivacion) {
      try {
        await axios
          .put(
            `PoliciaCuadrantes/C3/programacionesevaluaciones/${derivacion.fk_idProgramacion}/derivaciones/${derivacion.idDerivacion}`,
            derivacion,
          )
          .then(async () => {
            if (derivacion.fileSolicitud) {
              const formData = new FormData();
              formData.append('file', derivacion.fileSolicitud);
              formData.append('idDerivacion', derivacion.idDerivacion);
              await context.dispatch('uploadDerivacionSolicitud', formData);
              await context.dispatch('uploadDerivacionRespuesta', formData);
            }
            if (derivacion.file) {
              const formData2 = new FormData();
              formData2.append('file', derivacion.file);
              formData2.append('idDerivacion', derivacion.idDerivacion);
            }
            context.commit('SET_SNACKBAR_MESSAGE', 'Resultado de evaluación guardado correctamente.', {
              root: true,
            });
          });
      } catch (error) {
        context.commit('SET_SNACKBAR_MESSAGE', 'Ocurrió un error al intentar guardar la evaluación.', {
          root: true,
        });
      }
    },

    async updateEstatusDerivacion(context, derivacion) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/programacionesevaluaciones/${derivacion.fk_idProgramacion}/derivaciones/${derivacion.idDerivacion}/cierre`,
        )
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Evaluación guardada.', {
            root: true,
          });
        });
    },

    async rollbackEstatusDerivacion(_, derivacion) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/programacionesevaluaciones/${
            derivacion.fk_idProgramacion
          }/derivaciones/${
            derivacion.idDerivacion
          }/estatus`,
        );
    },

    async uploadDerivacion(context, formData) {
      await fileAxios
        .post('/C3/Derivacion/uploadFiles', formData)
        .then(() => {});
    },

    async uploadDerivacionRespuesta(context, formData) {
      await fileAxios
        .post('/C3/Derivacion/uploadOficioRespuesta', formData)
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Oficio de respuesta guardado correctamente.', {
            root: true,
          });
        });
    },

    async uploadDerivacionSolicitud(context, formData) {
      await fileAxios
        .post('/C3/Derivacion/uploadOficioSolicitud', formData)
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Oficio de solicitud guardado correctamente.', {
            root: true,
          });
        });
    },
  },
};
